export const NAME = 'ecpay2';